const INTERNAL = 'internal';
const EXTERNAL = 'external';

const SOURCE_CODE = 'Source Code';
const READ_MORE = 'Read More';
const YOUTUBE = 'YouTube';
const GO = 'Go!';
const PAPER = "Paper";
const DEMO = "Demo";

const visualization = 'visualization';
const processing = 'processing';
const dsp = 'dsp';
const inquiry = 'inquiry';
const hci = 'hci';
const android = 'android';
const mit_app_inventor = 'mit_app_inventor';
const high_school = 'high_school';
const python = 'python';
const js = 'js';
const animation = 'animation';
const art = 'art';
const lib = 'lib';
const react = 'react';
const real_time = 'real-time';
const music = 'music';
const colab = 'colab';
const frontend = 'frontend';
const html = 'html';
const not_coding = 'not_coding';
const matlab = 'matlab';
const simulation = 'simulation';
const fabrication = 'fabrication';
const self_ref = 'self_ref';
const jupyter_notebook = 'jupyter_notebook';
const sonification = 'sonification';
const computer_music = 'computer_music';
const math = 'math';
const nime = 'nime';
const circuit = 'circuit';
const game_tool = 'game_tool';
const voice = 'voice';
const vm = 'vm';
const ui = 'ui';
const game = 'game';
const godot = 'godot';
const game_jam = 'game_jam';
const performance = 'performance';
const scp = 'scp';
const physics = 'physics';
const geb = 'geb';
const _3d_print = '3d_print';

const portfolio_root = [
  {
    title : 'Personal Website', 
    year : 2020, 
    pride : 4, 
    tags : [html, js, frontend, react], 
    description : 'I have a project portfolio on there, did you know? ', 
    img : 'portfolio.png', 
    links: [
      [ DEMO, EXTERNAL, "__egg__" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/personal-website" ], 
    ], 
  }, 
  {
    title : 'Small Strange AdvenTure (SSAT)', 
    year : 2015, 
    pride : 6, 
    tags : ['vb', 'game', high_school, real_time], 
    description : 'Adventure game in VB. I implemented the 2D physics engine. My first OOP project (because there were an variable number of walls in a level). Many eastereggs... ', 
    img : 'ssat.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/SSAT" ], 
    ], 
  }, 
  {
    title : 'Poster for dorm', 
    year : 2018, 
    pride : 6, 
    tags : [art, visualization, processing, 'math', python], 
    description : 'Visualization of the Collatz conjecture. I hanged it in my NYU Shanghai dorm room. ', 
    img : 'PosterFor1608.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Processing/blob/master/PosterForDorm/PosterForDorm_pde/PosterForDorm_pde.pyde" ], 
    ], 
  }, 
  {
    title : 'WhereDitGo', 
    year : 2019, 
    pride : 5, 
    tags : [html, js, 'forsaken', frontend, 'backend'], 
    description : "Expense accounting app. The design doc is very detailed, but I decided it's not worth my time to implement it. ", 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/WhereDitGo" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/WhereDitGo#where-ditgo" ], 
    ], 
  }, 
  {
    title : 'coffeetawk', 
    year : 2018, 
    pride : 1, 
    tags : [html, js, frontend, 'app_lab'], 
    description : '', 
    img : '', 
    links: [
      [ "GIF", EXTERNAL, "https://giphy.com/gifs/oymRyMemkmjrKxcVHk" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/coffeetawk" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/coffeetawk#coffeetawk" ], 
    ], 
  }, 
  {
    title : 'Socrates', 
    year : 2018, 
    pride : 1, 
    tags : [html, js, frontend, 'app_lab', 'firebase', colab, react], 
    description : 'Colab with Vincent Wu', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Socrates" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/Socrates#socrates" ], 
    ], 
  }, 
  {
    title : 'js withDir', 
    year : 2019, 
    pride : 2, 
    tags : [js, lib], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/garbage_js_code_base/blob/master/withDir.js" ], 
    ], 
  }, 
  {
    title : 'js Interactive Tester', 
    year : 2019, 
    pride : 5, 
    tags : [js, lib, 'vm', 'npm', 'dev_tool'], 
    description : 'Test the functions and objects you wrote in a real-time terminal shell, analogous to `IPython.embed()`.', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Interactive-JS-Tester" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/Interactive-JS-Tester#interactive-js-tester" ], 
    ], 
  }, 
  {
    title : 'js Linked File List', 
    year : 2019, 
    pride : 6, 
    tags : [js, lib, 'npm', 'database'], 
    description : 'Each entry is a file, with id as its filename. A simple database solution, but highly scalable. Integrates version tracking with Git. ', 
    img : 'js_linked_files.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/LinkedFileList" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/LinkedFileList#double-linked-file-list" ], 
    ], 
  }, 
  {
    title : 'Dice Simulation', 
    year : 2019, 
    pride : 6, 
    tags : [matlab, physics, processing, visualization, simulation, colab, 'peskin', inquiry], 
    description : 'Can human cheat with perfect dice? I simulated dice rolls in Matlab and colored the initial condition space according to roll outcome. Colab with Michael Li. Supervise by Charles Peskin. ', 
    img : 'dice_sim.png', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/lm123dN5NC0" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/DiceSim" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/DiceSim#dice-simulation" ], 
    ], 
  }, 
  {
    title : 'NYU login page verify', 
    year : 2019, 
    pride : 5, 
    tags : [js, 'chrome_extension'], 
    description : 'Let this Chrome extension check whether the URL is "https://shibboleth.nyu.edu/"', 
    img : 'nyu_login_verify.png', 
    links: [
      [ "Store Page", EXTERNAL, "https://chrome.google.com/webstore/detail/nyu-login-page-verify/iocemmjdkjlfpnjdhofljbolljfeifdj" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/NYULoginPageVerify" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/NYULoginPageVerify#nyu-login-page-verify" ], 
    ], 
  }, 
  {
    title : 'Simulating liquid-gas interfaces and MCL with the IB method', 
    year : 2020, 
    pride : 6, 
    tags : [inquiry, physics], 
    description : 'Extend the Immersed Boundary method to simulate Moving Contact Lines (MCL).', 
    img : 'ib.gif', 
    links: [
      [ "Short Video Demo", EXTERNAL, "https://youtu.be/lbv9AeI2el4" ], 
      [ "Presentation", EXTERNAL, "https://youtu.be/-dizYKs2uFI?t=5" ], 
      [ "Paper", EXTERNAL, "https://doi.org/10.1063/5.0086452" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/droplet" ], 
    ], 
  }, 
  {
    title : 'World of Blogs', 
    year : 2019, 
    pride : 6, 
    tags : [html, js, frontend, 'backend', 'firebase', 'user_auth', 'security', 'express', react], 
    description : 'A blog platform that fights the info cacoon effect. Novel database structure that optimizes random sampling. Robust user auth that withstands even timing attacks. Supervised by James Ayres. ', 
    img : 'worldOfBlog_singout.png', 
    links: [
      [ GO, EXTERNAL, "https://world-of-blogs.herokuapp.com/" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/WorldOfBlogs" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/WorldOfBlogs#world-of-blogs" ], 
    ], 
  }, 
  {
    title : 'Nozomi.la AI', 
    year : 2020, 
    pride : 6, 
    tags : ['ai', html, js, python, 'html2api', 'backend', frontend, 'recommendation_algo', 'user_preferences', hci], 
    description : 'A recommendation algo learns your preferences of fan arts from your reactions. ', 
    img : 'nozomi_ai.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/nozomi.la-AI" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/nozomi.la-AI#nozomila-ai" ], 
    ], 
  }, 
  {
    title : 'Shape of Chords', 
    year : 2020, 
    pride : 6, 
    tags : ['p5.js', music, visualization, frontend, hci, 'math'], 
    description : 'Visualize chords on the complex plane using Fourier transform at root frequency.', 
    img : 'shape_of_chord.png', 
    links: [
      [ GO, EXTERNAL, "https://upbeat-volhard-31fdb8.netlify.app/" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/daniel-chin/shape-of-chords" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/shape-of-chords#shape-of-chords" ], 
    ], 
  }, 
  {
    title : "Daniel's Funplex on Ice", 
    year : 2020, 
    pride : 3, 
    tags : ['minecraft', not_coding, 'game'], 
    description : 'A funplex in Minecraft', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/myMinecraftWorlds/blob/master/Daniel's%20Funplex%20on%20Ice.mcworld" ], 
    ], 
  }, 
  {
    title : 'What Features Drive Demand High? Airbnb in New York, Fitting a Demand Surface', 
    year : 2020, 
    pride : 5, 
    tags : ['ai', 'machine_learning', colab, 'data_sci', colab, 'paper'], 
    description : 'Colab with Andrew Liu, Wendi Tang. Supervised by Xiao Liu. ', 
    img : 'airbnb.png', 
    links: [
      [ PAPER, INTERNAL, "airbnb.pdf" ], 
    ], 
  }, 
  {
    title : 'OPEC Auction Assistant', 
    year : 2020, 
    pride : 2, 
    tags : [html, ui, js], 
    description : '', 
    img : 'auction_assist.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/opec/tree/master/auction_assistant" ], 
    ], 
  }, 
  {
    title : 'Grandfather Paradox Solved with Mixed Strategy Equilibrium', 
    year : 2020, 
    pride : 6, 
    tags : [not_coding, 'game_theory', 'time_travel', 'paper'], 
    description : '', 
    img : '', 
    links: [
      [ PAPER, INTERNAL, "grandpa.pdf" ], 
    ], 
  }, 
  {
    title : '_December 2018', 
    year : 2018, 
    pride : 1, 
    tags : ['game', python, 'under_construction', hci], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/december2018" ], 
    ], 
  }, 
  {
    title : 'SCP 294 NLP AI', 
    year : 2020, 
    pride : 5, 
    tags : ['ai', 'nlp', scp, 'gpt-2', hci], 
    description : 'Predicts the result of consuming liquid from SCP 294 using GPT-2. ', 
    img : 'drink_lava.png', 
    links: [
      [ "Colab Notebook", EXTERNAL, "https://colab.research.google.com/drive/10DLgYVQYDVrTBjkcXWDrCAYmd3izelNJ?usp=sharing" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/SCP-294-NLP-AI" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/SCP-294-NLP-AI#predicting-the-result-of-consuming-liquid-from-scp-294-using-gpt-2" ], 
    ], 
  }, 
  {
    title : 'Incubus M.D.', 
    year : 2019, 
    pride : 4, 
    tags : [game, 'game_maker_lang', colab, game_jam], 
    description : 'Colab with Zane Fadul, Andrew Liu, Vera Zhong, Thomas Tai', 
    img : 'incubus.gif', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/ok" ], 
      [ READ_MORE, EXTERNAL, "https://globalgamejam.org/2020/games/incubus-md-6" ], 
    ], 
  }, 
  {
    title : 'Wage Simulation', 
    year : 2019, 
    pride : 6, 
    tags : [matlab, 'econ', 'peskin', simulation, 'paper'], 
    description : 'Simulate an economy. Wages go up when Thanos snaps his fingers. Supervised by Charles Peskin. ', 
    img : 'econ_thanos.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/WageSim" ], 
      [ PAPER, INTERNAL, "wage_sim.pdf" ], 
    ], 
  }, 
  {
    title : 'Tinder vs Bumble', 
    year : 2020, 
    pride : 4, 
    tags : [not_coding, 'video', colab], 
    description : 'Colab with Alex Zhao, Brielle Albert, Doraian, Rosalane Chow, Yolanda Liu', 
    img : 'tinder_bumble.png', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://www.youtube.com/watch?v=AgMrl5ueot0" ], 
    ], 
  }, 
  {
    title : 'Do Details Make People Buy into Bullshit?', 
    year : 2018, 
    pride : 4, 
    tags : ['psychology', python, 'cross_platform', 'tkinter', music], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Sound-Perception-Experiment" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/Sound-Perception-Experiment#do-details-make-people-buy-into-bullshit" ], 
    ], 
  }, 
  {
    title : 'Redstone: 5-bit password', 
    year : 2020, 
    pride : 3, 
    tags : ['minecraft', not_coding, 'game', 'redstone'], 
    description : '', 
    img : 'minecraft_5_bit.jpg', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/TAs_eDUG32Y" ], 
    ], 
  }, 
  {
    title : 'Mario XP', 
    year : 2018, 
    pride : 3, 
    tags : [music, 'audacity', 'game', 'joke'], 
    description : '', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/VYBsNTBjYeM" ], 
    ], 
  }, 
  {
    title : 'Spaghetti chat room', 
    year : 2018, 
    pride : 4, 
    tags : [python, js, html, 'backend', frontend], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/spaghetti-chat-room" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/spaghetti-chat-room#spaghetti-chat-room" ], 
    ], 
  }, 
  {
    title : 'Beat Swap Zane Fadul', 
    year : 2020, 
    pride : 5, 
    tags : [music, python, jupyter_notebook, computer_music], 
    description : 'I swapped some beats of some game OST composed by my friend Zane Fadul. ', 
    img : 'beat_swap.png', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://www.youtube.com/playlist?list=PLNb0mNThMXbn8XxE6-FwoaHdPxsVBg858" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/beat-swap/blob/main/main.ipynb" ], 
    ], 
  }, 
  {
    title : 'Simplinstrument', 
    year : 2019, 
    pride : 6, 
    tags : [colab, music, 'arduino', computer_music, processing, python, 'distributed_app', 'gui_2_api', _3d_print, hci, real_time, fabrication, nime], 
    description : 'You control the electronic musical instrument by moving your hand while breathing into a mouthpiece. Colab with Tristan Murdoch. ', 
    img : 'simplinstrument.png', 
    links: [
      [ READ_MORE, EXTERNAL, "https://wp.nyu.edu/shanghai-ima-documentation/foundations/interaction-lab/nq285/final-project-simplinstrument-by-daniel-chin/" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Interaction_Lab-NYU_Shanghai/tree/master/Final_project" ], 
    ], 
  }, 
  {
    title : 'Rotating Huskies', 
    year : 2019, 
    pride : 3, 
    tags : [processing, 'dog', 'joke'], 
    description : '', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://wp.nyu.edu/shanghai-ima-documentation/foundations/interaction-lab/nq285/recitation-11-midea-manipulation-workshop-by-daniel-chin/" ], 
    ], 
  }, 
  {
    title : 'Heat-sensitive webcam', 
    year : 2019, 
    pride : 3, 
    tags : [processing, 'joke', 'arduino', hci], 
    description : '', 
    img : 'heat_cam.jpg', 
    links: [
      [ READ_MORE, EXTERNAL, "https://wp.nyu.edu/shanghai-ima-documentation/foundations/interaction-lab/nq285/recitation-10-media-controller-by-daniel-chin/" ], 
    ], 
  }, 
  {
    title : 'laser arcade', 
    year : 2019, 
    pride : 6, 
    tags : [colab, 'arduino', processing, 'distributed_app', _3d_print, 'fusion_360', 'audacity', 'game', hci, fabrication], 
    description : 'An arcade machine. Do watch all videos in the demo. Colab with Tristan Murdoch. ', 
    img : 'laser_arcade.jpg', 
    links: [
      [ READ_MORE, EXTERNAL, "https://wp.nyu.edu/shanghai-ima-documentation/foundations/interaction-lab/nq285/laser-arcade-daniel-chin-marcela/" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Interaction_Lab-NYU_Shanghai/tree/master/midterm" ], 
    ], 
  }, 
  {
    title : 'Ink Leak Classic', 
    year : 2019, 
    pride : 2, 
    tags : [processing, animation, art, lib], 
    description : 'The GIF does not do justice. Run it yourself for HD 60 FPS. ', 
    img : 'ink_leak.gif', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Processing/tree/master/InkLeakLib" ], 
      [ READ_MORE, EXTERNAL, "https://wp.nyu.edu/shanghai-ima-documentation/foundations/interaction-lab/nq285/recitation-5-processing-basics-by-daniel-chin/" ], 
    ], 
  }, 
  {
    title : 'Mixed Strategies in Werewolf: Guardian vs Werewolves', 
    year : 2020, 
    pride : 3, 
    tags : [not_coding, 'game_theory', 'game', 'paper'], 
    description : 'Colab with Harry Huang, Vincent Wu, Aurora Yao', 
    img : '', 
    links: [
      [ PAPER, INTERNAL, "werewolf.pdf" ], 
    ], 
  }, 
  {
    title : 'Playing card design', 
    year : 2019, 
    pride : 3, 
    tags : [art, 'adobe_illustrator'], 
    description : 'Supervised by Will Varner', 
    img : 'playing_card.png', 
    links: [
      [ PAPER, INTERNAL, "playing_cards.pdf" ], 
    ], 
  }, 
  {
    title : 'Real-time auto tuner', 
    year : 2018, 
    pride : 6, 
    tags : [python, hci, dsp, real_time, music, colab], 
    description : 'Sing into the computer. The computer rounds your pitch to the nearest 12-tone-valid pitch, and plays it out with the speakers. Colab with Evan Ma, Saili Yao. Supervised by Gus Xia. ', 
    img : 'autotuner.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Real-time-Auto-tuner" ], 
      [ READ_MORE, EXTERNAL, "/#/documentation/real-time_auto_tune" ], 
    ], 
  }, 
  {
    title : 'Digital Rapper', 
    year : 2018, 
    pride : 4, 
    tags : [python, music, computer_music, jupyter_notebook, colab, dsp, nime], 
    description : 'Colab with Matthew, supervised by Gus Xia', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/qVQ67LeLSwU" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Digital-Rapper/blob/main/Rap_no_output.ipynb" ], 
    ], 
  }, 
  {
    title : "Pascal's Triangle Music", 
    year : 2018, 
    pride : 5, 
    tags : [python, music, sonification, computer_music, jupyter_notebook, math, nime], 
    description : "Translating the Pascal's triangle to music using Diatonic scale. ", 
    img : 'pascal_music.png', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/Ty0LiKrBLgs" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Pascal-s-Triangle-Music/blob/main/generate.ipynb" ], 
    ], 
  }, 
  {
    title : 'Bamboozle', 
    year : 2018, 
    pride : 5, 
    tags : ['joke', art], 
    description : '', 
    img : '', 
    links: [
      [ PAPER, INTERNAL, "bamboozle.html" ], 
    ], 
  }, 
  {
    title : 'Broom Closet Remastered', 
    year : 2019, 
    pride : 4, 
    tags : ['3d_model', 'maya', 'game', 'uv_mapping', 'texturing', 'lighting'], 
    description : 'Supervised by Cesar Guevara', 
    img : 'broom.jpg', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/gJItc8QrU6I" ], 
      [ "Maya File", INTERNAL, "broom_closet.mb" ], 
    ], 
  }, 
  {
    title : 'Hand Canon Model', 
    year : 2019, 
    pride : 4, 
    tags : ['3d_model', 'maya', 'texturing'], 
    description : 'Supervised by Cesar Guevara', 
    img : 'canon.png', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/hg6fpN6gqaA" ], 
      [ "Maya File", INTERNAL, "revolver.mb" ], 
    ], 
  }, 
  {
    title : 'Mouse adaptor', 
    year : 2019, 
    pride : 4, 
    tags : ['3d_model', 'maya', _3d_print], 
    description : '', 
    img : 'mouse_shell.jpg', 
    links: [
      [ READ_MORE, EXTERNAL, "/#/documentation/mouse_shell" ], 
    ], 
  }, 
  {
    title : 'Urban Voicinary', 
    year : 2019, 
    pride : 4, 
    tags : [js, react, frontend, hci, voice], 
    description : 'Supervised by James Ayres', 
    img : 'urban_voice.png', 
    links: [
      [ GO, EXTERNAL, "https://naughty-lalande-3e9746.netlify.app/" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Dynamic_Web/tree/master/midterm" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/Dynamic_Web/tree/master/midterm#urban-voicinary" ], 
    ], 
  }, 
  {
    title : 'Processing GUI Tree', 
    year : 2018, 
    pride : 6, 
    tags : [processing, 'gui', frontend, lib], 
    description : 'A GUI framework. A tree of GUI elements that renders recursively. Comes with 3 gadgets for free, too. ', 
    img : 'proc_gui_tree.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Processing/blob/master/GUILib/GUI.pde" ], 
    ], 
  }, 
  {
    title : 'Processing Routine Throttle', 
    year : 2019, 
    pride : 2, 
    tags : [processing, lib], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Processing/blob/master/TimerLib/TImer.pde" ], 
    ], 
  }, 
  {
    title : '24 solver', 
    year : 2020, 
    pride : 2, 
    tags : [python, 'algo', 'math'], 
    description : '', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#24solverpy" ], 
    ], 
  }, 
  {
    title : 'alarm', 
    year : 2020, 
    pride : 2, 
    tags : [python], 
    description : 'A python alarm clock, written only because the Win10 Alarm App UI is trash.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#alarmpy" ], 
    ], 
  }, 
  {
    title : '"Response Generator"', 
    year : 2017, 
    pride : 3, 
    tags : [python, 'p2p'], 
    description : '', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#archiveresponse-generator" ], 
    ], 
  }, 
  {
    title : 'RRRR Archiver', 
    year : 2019, 
    pride : 2, 
    tags : [python, 'data_scrape'], 
    description : '', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#archivearchive_rrrrpy" ], 
    ], 
  }, 
  {
    title : 'LAN scan', 
    year : 2017, 
    pride : 2, 
    tags : [python], 
    description : 'Scans the NYUSH LAN', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#archivelan_scan" ], 
    ], 
  }, 
  {
    title : 'Wechat MIM', 
    year : 2017, 
    pride : 2, 
    tags : [python], 
    description : 'A man-in-middle to figure out how Wechat PC client works. It failed. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/python-alt-stdlib/blob/master/Archive/legacy_archive/WechatMirror.py" ], 
    ], 
  }, 
  {
    title : 'LENOVO shipping', 
    year : 2018, 
    pride : 1, 
    tags : [python], 
    description : 'An attempt to implement SSH when I was young.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#archivelenovoshipping" ], 
    ], 
  }, 
  {
    title : 'Robust storage', 
    year : 2019, 
    pride : 3, 
    tags : [python, lib, 'database'], 
    description : 'Atomic database access immune to power-outage. Inspired by Undertale', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#archiverobust_persistent_data_solutionpy" ], 
    ], 
  }, 
  {
    title : 'Sleep prober', 
    year : 2019, 
    pride : 2, 
    tags : [python], 
    description : 'Keeps beeping, until the computer sleeps. Useful in rare occasions. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#archivesleepprober" ], 
    ], 
  }, 
  {
    title : 'ascii table', 
    year : 2019, 
    pride : 2, 
    tags : [python, 'dev_tool'], 
    description : 'A beautiful script. Next time you need to look at the ascii table, run this. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#ascii_tablepy" ], 
    ], 
  }, 
  {
    title : 'Beer on the wall', 
    year : 2017, 
    pride : 2, 
    tags : [python, 'joke'], 
    description : '', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#beer-on-the-wall" ], 
    ], 
  }, 
  {
    title : 'Book', 
    year : 2018, 
    pride : 6, 
    tags : [python, 'encryption'], 
    description : 'A file system. Encrypted system-wise with Fernet. ', 
    img : 'book.jpg', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#bookpy" ], 
    ], 
  }, 
  {
    title : 'cache no hash', 
    year : 2018, 
    pride : 2, 
    tags : [python, lib], 
    description : 'Cache function returns without hashing inputs. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#cache_no_hashpy" ], 
    ], 
  }, 
  {
    title : 'chdir context', 
    year : 2020, 
    pride : 2, 
    tags : [python, lib], 
    description : 'A python context to temporarily cd to another directory.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#chdir_contextpy" ], 
    ], 
  }, 
  {
    title : 'Clicker', 
    year : 2018, 
    pride : 5, 
    tags : [python, 'p2p', hci, 'http'], 
    description : 'Use your phone to send UP and DOWN to your computer! You can finally read papers with arms relaxed. ', 
    img : 'clicker.jpg', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#clickermainpy" ], 
    ], 
  }, 
  {
    title : 'Color Tiles', 
    year : 2018, 
    pride : 4, 
    tags : [python, 'game', 'cocos2d'], 
    description : 'The minigame from Undertale, implemented in python. ', 
    img : 'color_tile.png', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#color_tiles" ], 
    ], 
  }, 
  {
    title : 'Readme compiler', 
    year : 2019, 
    pride : 4, 
    tags : [python, 'meta'], 
    description : 'Iterate through all  files in my python repo and build a readme.md for the repo', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#compile_readmepy" ], 
    ], 
  }, 
  {
    title : 'Lightweight interactive Python shell', 
    year : 2018, 
    pride : 6, 
    tags : [python, lib, vm, 'dev_tool'], 
    description : "Just like IPython - supports runtime embed. But: 1) It's way lighter; 2) Other threads can still print things when user is inputting commands; 3) Tab auto-completes your phrase, even under Windows! 4) secret ctrl+R feature. ", 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#console" ], 
    ], 
  }, 
  {
    title : 'Count votes', 
    year : 2019, 
    pride : 2, 
    tags : [python], 
    description : 'For counting votes and ranking the counts.  ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#countpy" ], 
    ], 
  }, 
  {
    title : 'dict shape compare', 
    year : 2019, 
    pride : 2, 
    tags : [python, lib], 
    description : 'Compare the shape of two dicts. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#dict_shapepy" ], 
    ], 
  }, 
  {
    title : 'Find Vera', 
    year : 2017, 
    pride : 2, 
    tags : [python, 'game', 'ascii_game'], 
    description : 'A simple ascii game. ', 
    img : 'find_vera.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/python-alt-stdlib/blob/master/Find%20Vera/Find_Vera%20V2.py" ], 
    ], 
  }, 
  {
    title : 'Python flash player', 
    year : 2019, 
    pride : 2, 
    tags : [python, html], 
    description : 'Play .swf files with a browser. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#flashplayer" ], 
    ], 
  }, 
  {
    title : 'Folder Go', 
    year : 2020, 
    pride : 4, 
    tags : [python, 'p2p'], 
    description : 'Transmit a folder over the internet.  ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#folder_gopy" ], 
    ], 
  }, 
  {
    title : 'Force multithread map', 
    year : 2018, 
    pride : 2, 
    tags : [python, lib, 'multi_thread'], 
    description : 'Like dummy.Pool.map, but no limit on number of threads. Useful when IO-bound.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#forcemappy" ], 
    ], 
  }, 
  {
    title : 'non-ascii formula evaluation', 
    year : 2018, 
    pride : 4, 
    tags : [python], 
    description : 'I use this frequently for Finance problem sets. ', 
    img : 'formula.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib/blob/master/formula.py" ], 
    ], 
  }, 
  {
    title : 'Time formattor', 
    year : 2018, 
    pride : 2, 
    tags : [python, lib], 
    description : 'Obviously a wheel re-invted', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#friendly_timepy" ], 
    ], 
  }, 
  {
    title : 'Terminal graphic utils', 
    year : 2018, 
    pride : 4, 
    tags : [python, lib], 
    description : 'Tools to do graphics in the terminal.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#graphic_terminalpy" ], 
    ], 
  }, 
  {
    title : 'HTTP MIM', 
    year : 2019, 
    pride : 3, 
    tags : [python], 
    description : 'HTTP man in middle. Prints all traffic. Useful for investigating how http works. Although Chrome Dev Tools prolly have something like this already.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#httpmimpy" ], 
    ], 
  }, 
  {
    title : 'Socket Hub', 
    year : 2018, 
    pride : 2, 
    tags : [python, 'p2p', 'multi_thread', lib], 
    description : 'Broadcast messages from any client to all clients. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#hubpy" ], 
    ], 
  }, 
  {
    title : 'Indent printer', 
    year : 2019, 
    pride : 3, 
    tags : [python, lib], 
    description : 'A python context to indent print outputs. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#indentprinterpy" ], 
    ], 
  }, 
  {
    title : 'Android interactive file explorer', 
    year : 2018, 
    pride : 2, 
    tags : [python, lib, ui], 
    description : 'An android-friendly terminal file explorer. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#interactiveconsole_explorerpy" ], 
    ], 
  }, 
  {
    title : 'Terminal interactivity utils', 
    year : 2019, 
    pride : 6, 
    tags : [python, lib, ui], 
    description : 'Thicc and powerful. See the source code for documentation. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib/blob/master/interactive/__init__.py" ], 
    ], 
  }, 
  {
    title : 'ipynb to py', 
    year : 2019, 
    pride : 3, 
    tags : [python, jupyter_notebook], 
    description : 'Converts jupyter notebook file to python script. Works even when Jupyter is not installed.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#ipynb_to_pypy" ], 
    ], 
  }, 
  {
    title : 'python progress bar', 
    year : 2018, 
    pride : 3, 
    tags : [python, lib, ui], 
    description : 'Progress bar. Supports python context. Computes transmition speed too. ', 
    img : 'jdt.png', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#jdtpy" ], 
    ], 
  }, 
  {
    title : 'python linked file list', 
    year : 2019, 
    pride : 5, 
    tags : [python, lib, 'database'], 
    description : 'A simple database solution, but highly scalable.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#linked_file_listpy" ], 
    ], 
  }, 
  {
    title : 'Display local IP', 
    year : 2019, 
    pride : 2, 
    tags : [python, 'dev_tool'], 
    description : 'Find out local IP addr on Windows. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#local_ippy" ], 
    ], 
  }, 
  {
    title : 'Macro', 
    year : 2018, 
    pride : 5, 
    tags : [python, 'gui_2_api', 'multi_thread'], 
    description : 'Record, play, save, and load macros. Think AFK bot. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#macro" ], 
    ], 
  }, 
  {
    title : 'md 2 html', 
    year : 2019, 
    pride : 4, 
    tags : [python], 
    description : 'Translate markdown .md file to html file.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#md2htmlmainpy" ], 
    ], 
  }, 
  {
    title : 'Minecraft AFK', 
    year : 2020, 
    pride : 2, 
    tags : ['minecraft', game_tool], 
    description : '', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#minecraft_afkpy" ], 
    ], 
  }, 
  {
    title : 'Virtual Numpad', 
    year : 2020, 
    pride : 2, 
    tags : [python, 'p2p', html, js, frontend, hci, 'http', game_tool], 
    description : "Your laptop has no numpad? Can't play Cataclysm:DDA? No worries. Use your phone as a numpad!", 
    img : 'numpad.gif', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#mobilenumpad" ], 
    ], 
  }, 
  {
    title : 'more tkinter gadgets', 
    year : 2018, 
    pride : 3, 
    tags : [python, 'tkinter', lib, 'multi_thread'], 
    description : 'MsgBox, InputBox, other util functions…', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#moretkpy" ], 
    ], 
  }, 
  {
    title : 'Multi Terminal', 
    year : 2019, 
    pride : 5, 
    tags : [python, lib, 'multi_process', ui, 'multi_thread'], 
    description : 'Provides an interface to multiple terminal windows. E.g. for output of difference levels (debug, info, warning, error...)', 
    img : 'multi_term.png', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#multi_term" ], 
    ], 
  }, 
  {
    title : 'My HTTP', 
    year : 2018, 
    pride : 5, 
    tags : [python, 'http', lib, 'multi_thread'], 
    description : 'HTTP server in python. Each request is handled by a thread. Global event loop and message queue. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#myhttppy" ], 
    ], 
  }, 
  {
    title : 'Terminal ascii QR code', 
    year : 2019, 
    pride : 3, 
    tags : [python], 
    description : "Prints QR code to terminal. How useful. I can't imagine why nobody built this", 
    img : 'qr.png', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#myqrpy" ], 
    ], 
  }, 
  {
    title : 'My socket', 
    year : 2018, 
    pride : 2, 
    tags : [python, lib], 
    description : 'My socket utils', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#mysocketpy" ], 
    ], 
  }, 
  {
    title : 'netID 2 profile', 
    year : 2019, 
    pride : 3, 
    tags : [python], 
    description : 'For an NYU person, convert their netID to personal profile.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#netid2profilepy" ], 
    ], 
  }, 
  {
    title : 'One Ship', 
    year : 2018, 
    pride : 4, 
    tags : [python, 'p2p'], 
    description : 'Transmit a file over the internet / LAN. I frequently use it with friends. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#oneshippy" ], 
    ], 
  }, 
  {
    title : '力透纸背', 
    year : 2019, 
    pride : 2, 
    tags : [python], 
    description : '', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#pdf_litouzhibeipy" ], 
    ], 
  }, 
  {
    title : 'Pickle Preview', 
    year : 2019, 
    pride : 2, 
    tags : [python], 
    description : 'Preview a pickle file. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#pickle_previewmainpy" ], 
    ], 
  }, 
  {
    title : 'Pickle socket', 
    year : 2018, 
    pride : 1, 
    tags : [python, lib], 
    description : 'Send objects over sockets. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#pickle_socketpy" ], 
    ], 
  }, 
  {
    title : 'Play wav', 
    year : 2018, 
    pride : 2, 
    tags : [python], 
    description : 'Light-weight wav player. (Why does Windows Media Player take so long to launch?)', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#playwavpy" ], 
    ], 
  }, 
  {
    title : 'Port forward', 
    year : 2018, 
    pride : 4, 
    tags : [python, 'multi_thread'], 
    description : 'Forward socket traffic. Useful as a firewall. Is not thread safe - expect unexpected behaviors. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#port_forwardpy" ], 
    ], 
  }, 
  {
    title : 'Push git', 
    year : 2017, 
    pride : 1, 
    tags : [python], 
    description : 'Interactive git commit and push.  ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#push_gitpy" ], 
    ], 
  }, 
  {
    title : 'QR chat', 
    year : 2019, 
    pride : 3, 
    tags : [python, 'p2p', 'multi_thread'], 
    description : 'Sets up a server, displays a QR code. Scan it to go to a web page. Exchange raw texts!  ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#qrchatmainpy" ], 
    ], 
  }, 
  {
    title : 'Create React component', 
    year : 2019, 
    pride : 3, 
    tags : [python], 
    description : 'Creates a react component file containing boilerplate code. Prints code that imports this component. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#reactnewpy" ], 
    ], 
  }, 
  {
    title : 'Safe server', 
    year : 2019, 
    pride : 3, 
    tags : [python, 'http', html, 'security'], 
    description : 'A simple file server. Serves files in a folder. Has a simple HTML page interface.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#safeserver" ], 
    ], 
  }, 
  {
    title : 'Safe http', 
    year : 2019, 
    pride : 5, 
    tags : [python, 'http', 'security', lib], 
    description : 'An HTTP backend server baseclass. Really tries to be safe against injection attacks. Intentionally uses single thread only.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#safe_httppy" ], 
    ], 
  }, 
  {
    title : 'Serve now', 
    year : 2019, 
    pride : 1, 
    tags : [python, 'dev_tool'], 
    description : 'Immediately opens a port, accepts a connection and does nothing. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#serve_nowpy" ], 
    ], 
  }, 
  {
    title : 'Summarize dependencies', 
    year : 2019, 
    pride : 2, 
    tags : [python, 'dev_tool'], 
    description : 'Examines a directory of .py files and find all imports. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#summarize_dependenciespy" ], 
    ], 
  }, 
  {
    title : 'To the Earth', 
    year : 2017, 
    pride : 6, 
    tags : [python, 'game', 'ascii_game'], 
    description : 'A hard-core ascii-graphic adventure game in python. Tremendous eastereggs. ', 
    img : 'to_the_earth.png', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#to-the-earthto-the-earth-v8py" ], 
    ], 
  }, 
  {
    title : 'Typo fix', 
    year : 2019, 
    pride : 6, 
    tags : [python, hci, 'algo'], 
    description : 'I came up with an algorithm that fixes typos. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#typofix" ], 
    ], 
  }, 
  {
    title : 'Voice scroll', 
    year : 2020, 
    pride : 6, 
    tags : [python, hci, voice], 
    description : 'Reading papers? Hands off. Scroll down with your voice. ', 
    img : 'voice_scroll.png', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#voice_scrollpy" ], 
    ], 
  }, 
  {
    title : 'wget', 
    year : 2019, 
    pride : 2, 
    tags : [python], 
    description : 'Downloads a web resource.', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#wgetpy" ], 
    ], 
  }, 
  {
    title : 'force copy', 
    year : 2016, 
    pride : 1, 
    tags : ['vb'], 
    description : "Force copy a file even when it's locked", 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/ForceCopy" ], 
    ], 
  }, 
  {
    title : 'Gloper', 
    year : 2014, 
    pride : 4, 
    tags : ['vb', 'game', 'middle_school', music], 
    description : 'Dodge game. I made the OST. ', 
    img : 'gloper.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Gloper%20-%20Win" ], 
    ], 
  }, 
  {
    title : 'Password cracker', 
    year : 2015, 
    pride : 1, 
    tags : ['vb', high_school, 'hack'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Hack/Digit-For" ], 
    ], 
  }, 
  {
    title : '西江湾路模拟器', 
    year : 2015, 
    pride : 3, 
    tags : ['vb', simulation, colab], 
    description : 'MCM project. Simulate traffic in front of my school. Colab with Erwin Yonghao Xu, Andy Zhiyuan Le, and Yi Zhu. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/HIMCM%E8%A5%BF%E6%B1%9F%E6%B9%BE%E8%B7%AF%E6%A8%A1%E6%8B%9F%E5%99%A8" ], 
      [ PAPER, INTERNAL, "mcm_traffic.pdf" ], 
    ], 
  }, 
  {
    title : 'Aca pella machine', 
    year : 2015, 
    pride : 3, 
    tags : ['vb', matlab, high_school, music], 
    description : '', 
    img : '', 
    links: [
      [ "MP3", EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/blob/master/HeChangQi/History/ViVa%20Fail%20Vida/all.mp3" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/HeChangQi" ], 
    ], 
  }, 
  {
    title : 'How 2 Become A Calculater', 
    year : 2015, 
    pride : 5, 
    tags : ['vb', 'game', high_school, '3d_render_engine', real_time], 
    description : 'I had to write an algorithm to render 3D wireframe in VB using `line()` only. ', 
    img : 'calc.gif', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/W7YVeT05_f0" ], 
      [ "Baidu TieBa Post", EXTERNAL, "https://tieba.baidu.com/p/3899952413?fid=1177&pid=71695149496&cid=0&red_tag=2838761547#71695149496" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/How%202%20Become%20A%20Calculater" ], 
    ], 
  }, 
  {
    title : 'Intelink', 
    year : 2015, 
    pride : 5, 
    tags : ['vb', 'game', high_school, 'nlu', 'html2api', hci], 
    description : 'Related words form a path. ', 
    img : 'intelink.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Intelink" ], 
      [ YOUTUBE, EXTERNAL, "https://youtu.be/WTeQVXSBILE" ], 
    ], 
  }, 
  {
    title : 'Phonebook', 
    year : 2015, 
    pride : 6, 
    tags : ['vb', high_school, sonification, ui], 
    description : "Lookup my friends' phone number by typing into a rolling buffer. Phone number is read out loud using Javis, so I can dial while listening. ", 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Jack23" ], 
    ], 
  }, 
  {
    title : 'JackTimer', 
    year : 2015, 
    pride : 2, 
    tags : ['vb', high_school], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/JackTimer" ], 
    ], 
  }, 
  {
    title : 'Javis', 
    year : 2013, 
    pride : 6, 
    tags : ['vb', 't2s', matlab, high_school, hci, real_time, voice], 
    description : 'A Chinese text-to-speech bot that has my voice. I recorded myself speaking Chinese. Wrote a Matlab script to auto-annotate the audio and normalized it. VB had really bad audio control latency, so I had to have two audio players running simultaneously to pronounce characters in an alternating fashion. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Javis%E8%B4%BE%E7%BB%B4%E6%96%AF" ], 
    ], 
  }, 
  {
    title : 'John & Control', 
    year : 2015, 
    pride : 4, 
    tags : ['vb', high_school, 'evolution'], 
    description : 'Evolution of Johns. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/LetsRock" ], 
    ], 
  }, 
  {
    title : 'VB Game of Life', 
    year : 2015, 
    pride : 5, 
    tags : ['vb', high_school, simulation], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/LifeGame%E7%94%9F%E5%91%BD%E6%B8%B8%E6%88%8F" ], 
      [ PAPER, INTERNAL, "lifegame.pdf" ], 
    ], 
  }, 
  {
    title : 'Computer lock', 
    year : 2014, 
    pride : 5, 
    tags : ['vb', 'middle_school'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/locker" ], 
    ], 
  }, 
  {
    title : 'Pluto Encryption', 
    year : 2014, 
    pride : 5, 
    tags : ['vb', 'middle_school', 'encryption'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/M1%E5%86%A5%E7%8E%8B%E6%98%9F%E5%8A%A0%E5%AF%861%E4%BB%A3" ], 
    ], 
  }, 
  {
    title : 'GUI manual server', 
    year : 2018, 
    pride : 2, 
    tags : ['vb', 'dev_tool'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/ManualServer" ], 
    ], 
  }, 
  {
    title : 'JackStopwatch', 
    year : 2015, 
    pride : 2, 
    tags : ['vb', high_school], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/miaobiao%E6%9D%B0%E5%85%8B%E7%A7%92%E8%A1%A8" ], 
    ], 
  }, 
  {
    title : 'MIX', 
    year : 2017, 
    pride : 5, 
    tags : ['vb', 'vm'], 
    description : 'Implements MIX from TAOCP in VB. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/MIX" ], 
    ], 
  }, 
  {
    title : 'Notepad', 
    year : 2014, 
    pride : 2, 
    tags : ['vb', high_school, ui], 
    description : '', 
    img : 'notepad.gif', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/NotePad" ], 
    ], 
  }, 
  {
    title : 'Sun Encryption', 
    year : 2013, 
    pride : 5, 
    tags : ['vb', 'middle_school', 'encryption'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/3Sun%E5%A4%AA%E9%98%B3%E5%8A%A0%E5%AF%867" ], 
    ], 
  }, 
  {
    title : 'Bandwidth calculator', 
    year : 2014, 
    pride : 2, 
    tags : ['vb', 'middle_school'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/cewangsu%E6%B5%8B%E7%BD%91%E9%80%9F" ], 
    ], 
  }, 
  {
    title : 'IQ calculator', 
    year : 2014, 
    pride : 2, 
    tags : ['vb', 'middle_school', 'game', 'joke'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/cezhishang%E6%B5%8B%E6%99%BA%E5%95%86" ], 
    ], 
  }, 
  {
    title : 'Threebody simulation', 
    year : 2013, 
    pride : 3, 
    tags : ['vb', physics, 'middle_school', simulation], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/D2" ], 
    ], 
  }, 
  {
    title : '豆腐干四子棋', 
    year : 2014, 
    pride : 5, 
    tags : ['vb', 'middle_school', 'game'], 
    description : '', 
    img : 'doufugan.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/doufugan%E8%B1%86%E8%85%90%E5%B9%B2%E5%9B%9B%E5%AD%90%E6%A3%8B" ], 
    ], 
  }, 
  {
    title : 'VB progress bar', 
    year : 2014, 
    pride : 2, 
    tags : ['vb', 'middle_school', lib], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/jindu%E8%BF%9B%E5%BA%A6%E6%9D%A1" ], 
    ], 
  }, 
  {
    title : '"MATLAB assistant"', 
    year : 2014, 
    pride : 3, 
    tags : ['vb', 'middle_school', 'joke'], 
    description : 'Inject code into MATLAB startup script. A joke. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/Matlab%E5%8A%A9%E6%89%8B" ], 
    ], 
  }, 
  {
    title : 'The Matrix', 
    year : 2014, 
    pride : 5, 
    tags : ['vb', 'middle_school', 'evolution'], 
    description : '', 
    img : 'matrix.gif', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/Matrix" ], 
    ], 
  }, 
  {
    title : 'Minecraft study', 
    year : 2013, 
    pride : 3, 
    tags : ['vb', 'middle_school', 'minecraft'], 
    description : 'Opens a random gamepedia page every 5 minutes. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/MCstudy" ], 
    ], 
  }, 
  {
    title : 'Minecraft gamertag editor', 
    year : 2014, 
    pride : 2, 
    tags : ['vb', 'middle_school', 'minecraft'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/MC%E5%90%8D%E5%AD%97%E4%BF%AE%E6%94%B9%E5%99%A8" ], 
    ], 
  }, 
  {
    title : 'Screen protector for grandma', 
    year : 2014, 
    pride : 2, 
    tags : ['vb', 'middle_school'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/nainai%E5%A5%B6%E5%A5%B6%E6%B8%B8%E6%88%8F" ], 
    ], 
  }, 
  {
    title : 'Screen recorder assistant', 
    year : 2014, 
    pride : 3, 
    tags : ['vb', 'middle_school'], 
    description : 'Highlight/block part of the screen. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/p%E5%B1%8F%E5%B9%95%E5%BD%95%E5%83%8F%E5%8A%A9%E6%89%8B" ], 
    ], 
  }, 
  {
    title : 'QQ ID and Pi', 
    year : 2013, 
    pride : 6, 
    tags : ['vb', 'middle_school', 'math'], 
    description : 'Does Pi contain your qq id? ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/blob/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/qq%E5%8F%B7%E4%B8%8E%E5%9C%86%E5%91%A8%E7%8E%87/Form1.frm" ], 
    ], 
  }, 
  {
    title : "Dr. Stanley's House II Stone of Light practice", 
    year : 2013, 
    pride : 3, 
    tags : ['vb', 'middle_school'], 
    description : '', 
    img : 'stanley_light.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/SII" ], 
    ], 
  }, 
  {
    title : 'Hex Gomoku', 
    year : 2014, 
    pride : 3, 
    tags : ['vb', 'middle_school', 'game'], 
    description : '', 
    img : 'hex_gomoku.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/Six%E6%A3%8B" ], 
    ], 
  }, 
  {
    title : 'Brownian button', 
    year : 2013, 
    pride : 3, 
    tags : ['vb', 'middle_school', 'joke'], 
    description : 'Bad HCI', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/blob/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/VB%20HIS/%E5%B8%83%E6%9C%97%E8%BF%90%E5%8A%A8.exe" ], 
    ], 
  }, 
  {
    title : 'World of Wars', 
    year : 2013, 
    pride : 2, 
    tags : ['vb', 'middle_school', 'joke'], 
    description : 'A prank. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/W.o.w" ], 
    ], 
  }, 
  {
    title : 'Generalized Sierpinski triangles', 
    year : 2013, 
    pride : 6, 
    tags : ['vb', 'middle_school', visualization, 'math'], 
    description : "I tried Pascal's triangle MOD n. At that time I didn't know it was Sierpinski's triangle. But hey, here is a family of them. ", 
    img : 'sir_triangle.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/y" ], 
    ], 
  }, 
  {
    title : '看看你能坚持几秒', 
    year : 2013, 
    pride : 2, 
    tags : ['vb', 'middle_school', 'game'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/%E7%9C%8B%E7%9C%8B%E4%BD%A0%E8%83%BD%E5%9D%9A%E6%8C%81%E5%87%A0%E7%A7%92" ], 
    ], 
  }, 
  {
    title : 'Love letter encryption', 
    year : 2013, 
    pride : 1, 
    tags : ['vb', 'middle_school', 'encryption'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/%E6%83%85%E4%B9%A6%E5%8A%A0%E5%AF%86" ], 
    ], 
  }, 
  {
    title : "Heron's formula", 
    year : 2013, 
    pride : 2, 
    tags : ['vb', 'middle_school'], 
    description : 'School pride and eastereggs. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/%E4%B8%89%E8%A7%92%E5%BD%A2%E9%9D%A2%E7%A7%AF%E6%B1%82%E8%A7%A3%E5%99%A8%20%E6%B5%B7%E4%BC%A6%E5%85%AC%E5%BC%8F%2020100717/images" ], 
    ], 
  }, 
  {
    title : '手速小游戏', 
    year : 2013, 
    pride : 2, 
    tags : ['vb', 'middle_school', 'game'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/%E6%89%8B%E9%80%9F" ], 
    ], 
  }, 
  {
    title : 'Gomoku tie probability', 
    year : 2013, 
    pride : 6, 
    tags : ['vb', 'middle_school', 'math'], 
    description : 'What is the probability of tie if both players play randomly in Gomoku? I wrote a Monte Carlo in VB. I posted my results on a forum and a bunch of university students invited me to their chess AI research QQ group. They were using alpha-beta branch cutting. After alpha-go, the group chat became a social chat. ', 
    img : 'gomoku_tie.png', 
    links: [
      [ "Baidu TieBa Post", EXTERNAL, "https://tieba.baidu.com/p/2549495225?pid=37769614768&cid=0&red_tag=3024125774#37769614768" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Old%E5%85%88%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84VB/%E4%BA%94%E5%AD%90%E6%A3%8B%E5%B9%B3%E5%B1%80%E6%A6%82%E7%8E%87" ], 
    ], 
  }, 
  {
    title : "Oxford learner's dict client", 
    year : 2014, 
    pride : 2, 
    tags : ['vb', high_school], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Ox%E7%89%9B%E6%B4%A5%E5%AD%A6%E8%80%85%E5%AD%97%E5%85%B8" ], 
    ], 
  }, 
  {
    title : 'Pixel Dungeon Bot', 
    year : 2017, 
    pride : 4, 
    tags : ['vb', 'bot', 'gui_2_api'], 
    description : 'Failsafe. Many demos.', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/blob/master/PixelWater/Form1.frm" ], 
    ], 
  }, 
  {
    title : 'JackDiary', 
    year : 2015, 
    pride : 2, 
    tags : ['vb', high_school, 'encryption'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/riji" ], 
    ], 
  }, 
  {
    title : 'Stocket', 
    year : 2016, 
    pride : 6, 
    tags : ['vb', 'finance', 'game', 'multi_player', high_school, real_time], 
    description : 'Stock + Market = Stocket… It also resembles "socket"… ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Stocket%E8%82%A1%E5%B8%82%E6%A8%A1%E6%8B%9F" ], 
    ], 
  }, 
  {
    title : 'Stream xor encryption', 
    year : 2016, 
    pride : 1, 
    tags : ['vb', high_school, 'encryption'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Stream" ], 
    ], 
  }, 
  {
    title : 'SuperCode', 
    year : 2014, 
    pride : 5, 
    tags : ['vb', high_school, 'encryption'], 
    description : '', 
    img : '', 
    links: [
      [ "The Idea", EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/blob/master/SuperCode/%E8%AF%B4%E6%98%8E/ReadMe.txt#L43" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/SuperCode" ], 
    ], 
  }, 
  {
    title : 'Time Clicker bot', 
    year : 2017, 
    pride : 1, 
    tags : ['vb', 'middle_school', 'bot'], 
    description : 'ASUS had an extra button. I used it as the panic button. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/TimeClicker" ], 
    ], 
  }, 
  {
    title : 'Uplink Bible', 
    year : 2016, 
    pride : 1, 
    tags : ['vb', high_school, 'encryption'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/UplinkBible" ], 
    ], 
  }, 
  {
    title : 'Uplink crackor', 
    year : 2015, 
    pride : 1, 
    tags : ['vb', high_school, 'hack'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/UplinkBreaker" ], 
    ], 
  }, 
  {
    title : 'Win8 fullscreen fixer', 
    year : 2015, 
    pride : 4, 
    tags : ['vb', high_school, hci], 
    description : 'Uses my T2S lib to say cursor coordinates. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/Win8FullscreenFixer" ], 
    ], 
  }, 
  {
    title : 'Caption border macro', 
    year : 2015, 
    pride : 3, 
    tags : ['vb', high_school, 'macro'], 
    description : 'I used to make lets play videos with Windows 7 Media Editor. It did not support batch edit. This macro formats all close captions in a project using a hotkey loop. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/ZiMu%E5%AD%97%E5%B9%95%E5%8A%A0%E6%A1%86" ], 
    ], 
  }, 
  {
    title : 'Inquiry into linear transformation', 
    year : 2015, 
    pride : 4, 
    tags : ['vb', high_school, inquiry, 'math', visualization], 
    description : 'User can transform a shape in real-time by manipulating a matrix. I wrote it to help me get the intuition of linear tranformation. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/%E5%8F%98%E6%8D%A2%E7%9F%A9%E9%98%B5" ], 
    ], 
  }, 
  {
    title : 'Vine growth', 
    year : 2015, 
    pride : 4, 
    tags : ['vb', high_school, art], 
    description : '', 
    img : 'vine.gif', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/%E7%AA%97%E8%8A%B1%E5%AE%9E%E9%AA%8C" ], 
    ], 
  }, 
  {
    title : 'Classmate sampler', 
    year : 2015, 
    pride : 2, 
    tags : ['vb', high_school, 'joke'], 
    description : '"Randomly" select a classmate. I used it to cold-call Erwin in a class presentation. ', 
    img : 'random_producer.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/%E5%90%8C%E5%AD%A6%E8%B0%83%E5%8F%96%E6%9C%BA" ], 
    ], 
  }, 
  {
    title : 'Imaginary plotter', 
    year : 2016, 
    pride : 1, 
    tags : ['vb', high_school, 'math', visualization], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/%E8%99%9A%E6%95%B0%E4%BD%9C%E5%9B%BE" ], 
    ], 
  }, 
  {
    title : 'Mate selection simulation', 
    year : 2016, 
    pride : 5, 
    tags : ['vb', high_school, simulation, 'evolution', inquiry], 
    description : 'Simulate a bi-sexual world evolution with sexual traits and sexual orientation traits inheritable. ', 
    img : 'bi_sex_evo.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/%E5%8E%8B%E5%80%92%E6%80%A7%E4%BC%98%E5%8A%BF" ], 
    ], 
  }, 
  {
    title : '延迟斩杀', 
    year : 2016, 
    pride : 4, 
    tags : ['vb', high_school, 'math', 'game_theory'], 
    description : '', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/VB-Projects-Middleschool/tree/master/%E5%BB%B6%E8%BF%9F%E6%96%A9%E6%9D%80" ], 
      [ PAPER, INTERNAL, "yanchizhansha.pdf" ], 
    ], 
  }, 
  {
    title : 'Tetris for Android', 
    year : 2018, 
    pride : 1, 
    tags : [android, 'java', 'game'], 
    description : 'Built with GDX. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/tetris-android" ], 
      [ "APK Installer", INTERNAL, "tetris.apk" ], 
    ], 
  }, 
  {
    title : 'Wechat moments (朋友圈) data scrape + client viewer', 
    year : 2018, 
    pride : 5, 
    tags : [python, 'data_scrape', 'tkinter'], 
    description : '', 
    img : 'moments_data.png', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Wechat-Moments-data-scrape-and-client-viewer" ], 
    ], 
  }, 
  {
    title : 'Undertale 南山南 remix', 
    year : 2017, 
    pride : 3, 
    tags : [music, 'remix', 'undertale', not_coding], 
    description : '', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/4eWzu_1WSgM" ], 
    ], 
  }, 
  {
    title : 'Air bridge', 
    year : 2017, 
    pride : 2, 
    tags : [music, not_coding], 
    description : '', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/SdJcBPuh-UA" ], 
    ], 
  }, 
  {
    title : 'Audio puzzles', 
    year : 2017, 
    pride : 3, 
    tags : [dsp, matlab, 'puzzle'], 
    description : 'Can you find the secret message? ', 
    img : '', 
    links: [
      [ "Download Puzzle", INTERNAL, "AudioPuzzle.zip" ], 
    ], 
  }, 
  {
    title : 'Math thoughts 2012', 
    year : 2012, 
    pride : 2, 
    tags : [not_coding, 'math'], 
    description : 'I had a notebook where I put math/sci thoughts in', 
    img : '', 
    links: [
      [ "Download Thoughts", INTERNAL, "Mazl.zip" ], 
    ], 
  }, 
  {
    title : 'Metro station modeling', 
    year : 2014, 
    pride : 1, 
    tags : [colab, 'paper'], 
    description : 'MCM project. Models people flow in a metro station. Colab with Erwin Yonghao Xu, Andy Zhiyuan Le, and Yi Zhu. I contributed relatively little work. ', 
    img : '', 
    links: [
      [ PAPER, INTERNAL, "metro_station.pdf" ], 
    ], 
  }, 
  {
    title : 'Summer bug', 
    year : 2015, 
    pride : 2, 
    tags : [not_coding, music], 
    description : '', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/mY1fbKmzurI" ], 
    ], 
  }, 
  {
    title : 'Song for WCJ', 
    year : 2014, 
    pride : 3, 
    tags : [not_coding, music], 
    description : '', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/Y4pmvQ_O0ac" ], 
    ], 
  }, 
  {
    title : 'His theme + the World Revolving', 
    year : 2018, 
    pride : 2, 
    tags : [not_coding, music, 'remix', 'undertale'], 
    description : '', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/js6Ix7vczis" ], 
    ], 
  }, 
  {
    title : 'Black Bamboo', 
    year : 2017, 
    pride : 3, 
    tags : [not_coding, music], 
    description : '', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/M-KpYGP4gL8" ], 
    ], 
  }, 
  {
    title : 'Generating Mutually Trusted Randomness in P2P', 
    year : 2020, 
    pride : 6, 
    tags : ['info_theory', 'game_theory'], 
    description : '', 
    img : '', 
    links: [
      [ PAPER, INTERNAL, "mutal_random.pdf" ], 
    ], 
  }, 
  {
    title : 'Real-time Benchmarking of Pitch Estimators', 
    year : 2020, 
    pride : 2, 
    tags : [music, python, jupyter_notebook, 'tensorflow', real_time], 
    description : 'Modified YIN and Crepe to real-time. Proposed SFT (Slow Fourier Transform)-based cepstrum peak interpolation. Benchmarked the three. ', 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Real-time-Benchmarking-of-Pitch-Estimators" ], 
    ], 
  }, 
  {
    title : 'Interactive Visualization of Spectral Leakage', 
    year : 2020, 
    pride : 4, 
    tags : [processing, visualization, dsp, 'math', inquiry], 
    description : '', 
    img : 'spectral_leak.gif', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Interactively-VIsualize-Spectral-Leakage" ], 
    ], 
  }, 
  {
    title : 'Blind Descend', 
    year : 2020, 
    pride : 4, 
    tags : [python, lib, 'algo'], 
    description : 'Efficiently find local minima of 1D functions without gradient. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#blinddescendpy" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib/blob/master/blindDescend.py" ], 
    ], 
  }, 
  {
    title : 'Cepstrogram: Microphone Short-time Cepstrum', 
    year : 2020, 
    pride : 3, 
    tags : [processing, visualization, dsp, inquiry], 
    description : 'Real-time Cepstrogram visualization in Processing 3. ', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/aEuAKBlFn0w" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Cepstrogram-Microphone-Short-time-Cepstrum" ], 
    ], 
  }, 
  {
    title : 'Notax', 
    year : 2017, 
    pride : 2, 
    tags : [hci, android, mit_app_inventor, high_school], 
    description : 'To do list, as Android notifications. ', 
    img : 'notax.jpg', 
    links: [
      [ SOURCE_CODE, INTERNAL, "notax.aia" ], 
    ], 
  }, 
  {
    title : 'Sleep Fire', 
    year : 2016, 
    pride : 2, 
    tags : [hci, android, mit_app_inventor, high_school], 
    description : 'The light switch was too far away from my bed, but I wanted to go into my bed while being able to see. This app turns the flashlight on, counts down, and turns it off. ', 
    img : 'sleep_fire.png', 
    links: [
      [ SOURCE_CODE, INTERNAL, "sleep_fire.aia" ], 
    ], 
  }, 
  {
    title : 'MS Word-generated HTML cleaning', 
    year : 2020, 
    pride : 2, 
    tags : [python], 
    description : 'Re-encodes to utf-8 and removes MS Outlook-specific metadata. Shrinks file size by ~60%. I use it to publish blogs on my personal website. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#cleanwordhtmlpy" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib/blob/master/cleanWordHtml.py" ], 
    ], 
  }, 
  {
    title : 'Ink Leak', 
    year : 2021, 
    pride : 5, 
    tags : [js, animation, art, lib, react], 
    description : 'A React component that animate texts as a canvas. ', 
    img : '__ink_leak__', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/InkLeak#ink-leak" ], 
    ], 
  }, 
  {
    title : 'Stream Profiler', 
    year : 2021, 
    pride : 3, 
    tags : [python, lib, real_time], 
    description : 'Profiles the computation time of a series of actions in a real-time stream-base application. ', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#streamprofilerpy" ], 
    ], 
  }, 
  {
    title : 'Sustain Pedal for Voice', 
    year : 2021, 
    pride : 6, 
    tags : [python, music, dsp, real_time, hci, voice], 
    description : 'Wanna sing chords but only have one mouth? ', 
    img : '', 
    links: [
      [ "YouTube 1", EXTERNAL, "https://youtu.be/PxjjnCc7VJw" ], 
      [ "YouTube 2", EXTERNAL, "https://youtu.be/9ino2go_F9k" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/Sustain-Pedal-for-Voice#sustain-pedal-for-voice" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Sustain-Pedal-for-Voice" ], 
    ], 
  }, 
  {
    title : 'imalading', 
    year : 2021, 
    pride : 3, 
    tags : [html, js, frontend], 
    description : 'Tool for my LA job. ', 
    img : 'imalading.png', 
    links: [
      [ GO, EXTERNAL, "https://wonderful-meninsky-5e3135.netlify.app/" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/imalading#imalading" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/imalading" ], 
    ], 
  }, 
  {
    title : 'Sound of calligraphy', 
    year : 2021, 
    pride : 2, 
    tags : [not_coding], 
    description : '', 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "/#/documentation/sound_of_calligraphy" ], 
    ], 
  }, 
  {
    title : 'Soup', 
    year : 2021, 
    pride : 5, 
    tags : [matlab, simulation, inquiry], 
    description : 'Simulate a soup of positive and negative masses. ', 
    img : 'soup.gif', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/BERUmHHRzA0" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/daniel-chin/soup" ], 
    ], 
  }, 
  {
    title : '鞋音', 
    year : 2021, 
    pride : 5, 
    tags : [fabrication, music], 
    description : 'Speaker in a shoe. Supervised by Eric Parren. ', 
    img : 'xie_yin.jpg', 
    links: [
      [ READ_MORE, EXTERNAL, "/#/documentation/xie_yin" ], 
    ], 
  }, 
  {
    title : 'Processing 3 Quine', 
    year : 2021, 
    pride : 5, 
    tags : [processing, self_ref], 
    description : 'This sketch produces a sketch editor containing its own source code. ', 
    img : '', 
    links: [
      [ DEMO, INTERNAL, "processing_quine.zip" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Processing/tree/master/quine" ], 
    ], 
  }, 
  {
    title : 'Sonification of Sierpinski triangle', 
    year : 2021, 
    pride : 3, 
    tags : [python, jupyter_notebook, dsp, math, sonification, computer_music, music, nime], 
    description : 'Directly translate the Sierpinski triangle to sound. This is probably a subset of bitwise operation generated music. ', 
    img : '', 
    links: [
      [ "Sample 0", INTERNAL, "sierpinski_sonification_demo_0.mp3" ], 
      [ "Sample 1", INTERNAL, "sierpinski_sonification_demo_1.mp3" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Sonification-of-Sierpinski-triangle/blob/main/sierpinski.ipynb" ], 
    ], 
  }, 
  {
    title : 'Better Ins', 
    year : 2021, 
    pride : 3, 
    tags : [music, computer_music, hci, nime], 
    description : 'Map gesture to sound. Primitive prototype. Supervised by Eric Parren. ', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/uBThrG-zqPM?list=PLNb0mNThMXblG0dK-Nn2zbvm8S2aK1iqc" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/NIME-with-Parren/tree/main/better_ins" ], 
      [ "WP.NYU", EXTERNAL, "https://wp.nyu.edu/nyushanghai-dcdt/2021/04/28/weekly-performance-better-instruments/" ], 
    ], 
  }, 
  {
    title : 'Signal is Noise + Chord Swiper with LEDs', 
    year : 2021, 
    pride : 5, 
    tags : [computer_music, nime, python, circuit], 
    description : 'Generate angry signals with analog circuits. Supervised by Eric Parren. ', 
    img : 'chord_swiper.jpg', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/lYIWHZsMQYQ" ], 
      [ "WP.NYU", EXTERNAL, "https://wp.nyu.edu/nyushanghai-dcdt/2021/05/14/signal-is-noise-chord-swiper-with-leds/" ], 
    ], 
  }, 
  {
    title : 'Hyper-hybrid Flute', 
    year : 2021, 
    pride : 4, 
    tags : [computer_music, nime, fabrication, hci, _3d_print, colab], 
    description : "Published in NIME 2021. A new interface which can be toggled between its electronic mode and its acoustic mode. In its acoustic mode, the interface is identical to the regular six-hole recorder. In its electronic mode, the interface detects the player's fingering and breath velocity and translates them to MIDI messages. Specifically, it maps higher breath velocity to higher octaves, with the modulo remainder controlling the microtonal pitch bend. This novel mapping reproduces a highly realistic flute-playing experience. Furthermore, changing the parameters easily augments the interface into a hyperinstrument that allows the player to control microtones more expressively via breathing techniques. Colab with Ian Zhang. Supervised by Gus Xia. ", 
    img : 'hhf.jpg', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/UIqsYK9F4xo" ], 
      [ "Bilibili", EXTERNAL, "https://www.bilibili.com/video/BV19U4y1V74e" ], 
      [ "Poster", INTERNAL, "hhf.pdf" ], 
      [ "Keyboard-and-Mouse Demo", EXTERNAL, "https://github.com/Daniel-Chin/HHF_NIME2021" ], 
      [ PAPER, EXTERNAL, "https://nime.pubpub.org/pub/eshr" ], 
      [ "More YouTube", EXTERNAL, "https://youtu.be/Qd3r8vkchTA?list=PLNb0mNThMXbmgJnrexhxPXHmCnZRUUFPY" ], 
      [ "More Bilibili", EXTERNAL, "https://www.bilibili.com/video/BV1Ay4y1n7LP" ], 
    ], 
  }, 
  {
    title : 'Screen cable', 
    year : 2021, 
    pride : 3, 
    tags : [python], 
    description : "Playback a section of your screen. Useful for sharing PPT (with speaker notes on) over Tencent (VooV) Meeting. ", 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#screencablemainpy" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib/blob/master/screenCable/__main__.py" ], 
    ], 
  }, 
  {
    title : 'Hybrid synth', 
    year : 2021, 
    pride : 5, 
    tags : [python, dsp, computer_music, real_time], 
    description : "Uses HarmonicSynth (precise) for the lower pitches; and IfftSynth (fast) for the higher pitches. ", 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib/blob/master/hybridSynth.py" ], 
      [ "HarmonicSynth", EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#harmonicsynthpy" ], 
      [ "ifftSynth", EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib#ifftsynthpy" ], 
    ], 
  }, 
  {
    title : 'Stellaris game assistant', 
    year : 2021, 
    pride : 2, 
    tags : [python, game_tool], 
    description : "Assignes hotkey to planet prev/next buttons and pop growth specification buttons. ", 
    img : '', 
    links: [
      [ SOURCE_CODE, EXTERNAL, "https://github.com/daniel-chin/python-alt-stdlib/blob/master/stellaris/__main__.py" ], 
    ], 
  }, 
  {
    title : 'One-person a cappella live', 
    year : 2021, 
    pride : 6, 
    tags : [python, dsp, computer_music, real_time, nime, voice, hci], 
    description : "Play chords on a MIDI keyboard and use your voice to... voice it. ", 
    img : 'opal.png', 
    links: [
      [ "Bohemian Rhapsody YouTube", EXTERNAL, "https://youtu.be/dygKL4RDmvU" ], 
      [ "Bohemian Rhapsody Bilibili", EXTERNAL, "https://www.bilibili.com/video/BV1Xq4y1W7aL/" ], 
      [ "Video Explanation YouTube", EXTERNAL, "https://youtu.be/uKA5eqZypM0" ], 
      [ "Video Explanation Bilibili", EXTERNAL, "https://www.bilibili.com/video/BV1cf4y157ux/" ], 
      [ "Video Presentation YouTube", EXTERNAL, "https://youtu.be/QOtcpMk6jT0" ], 
      [ "How it Works", EXTERNAL, "https://github.com/Daniel-Chin/one-person-a-cappella-live/blob/main/demos/technicalDetails.pptx?raw=true" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/one-person-a-cappella-live" ], 
    ], 
  }, 
  {
    title : 'Mini Python', 
    year : 2021, 
    pride : 4, 
    tags : [python, vm], 
    description : "A mini Python interpreter, written in Python 3. ", 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/mini-Python#mini-python" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/mini-Python" ], 
    ], 
  }, 
  {
    title : 'American-British English translator', 
    year : 2021, 
    pride : 2, 
    tags : [python], 
    description : "Forked from Kyle Willett, added user interactivity.", 
    img : '', 
    links: [
      [ READ_MORE, EXTERNAL, "https://github.com/Daniel-Chin/common_language#common_language" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/common_language" ], 
    ], 
  }, 
  {
    title : 'Field of Hopes and Dreams + Ragtime Osohe', 
    year : 2021, 
    pride : 2, 
    tags : [not_coding, music, 'remix', 'undertale', 'mother3'], 
    description : '', 
    img : '', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/sGtptSO12UU" ], 
    ], 
  }, 
  {
    title : 'Pokemon type interactive chart', 
    year : 2022, 
    pride : 4, 
    tags : [game_tool, react, ui], 
    description : '', 
    img : 'poke_type.png', 
    links: [
      [ GO, EXTERNAL, "https://elastic-wilson-e832cb.netlify.app/" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Pokemon-Type-Chart-Interactive" ], 
    ], 
  }, 
  {
    title : 'Self-sync with locality on sphere and torus', 
    year : 2022, 
    pride : 4, 
    tags : [visualization, processing, simulation, inquiry], 
    description : 'Self synchronization with finite light speed (locality) and closed boundaries (sphere, torus). ', 
    img : 'pulsation.gif', 
    links: [
      [ DEMO, EXTERNAL, "/#/blog/self_sync_locality" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/self-sync-w-finite-light-speed-and-closed-boundary" ], 
    ], 
  }, 
  {
    title : 'Dice Evolution', 
    year : 2022, 
    pride : 5, 
    tags : [game, godot, game_jam, colab], 
    description : 'A game made in 48 hours during GMTK game jam 2022. Uou have a powerful ability to alter the dice that decide your fate. Colab with Alith.', 
    img : 'dice_evolution.png', 
    links: [
      [ GO, EXTERNAL, "https://alith.itch.io/dice-evolution" ], 
      [ READ_MORE, EXTERNAL, "https://github.com/Alith-Game-Studio/Dice-Evolution#dice-evolution" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Alith-Game-Studio/Dice-Evolution" ], 
      [ 'GMTK Jam 2022', EXTERNAL, "https://itch.io/jam/gmtk-jam-2022" ], 
    ], 
  }, 
  {
    title : 'Music from far lands and near future', 
    year : 2022, 
    pride : 5, 
    tags : [performance, music, colab], 
    description : 'A concert Music X lab held in Dubai. Enjoy our music and understand our vision.', 
    img : 'concertDubai.png', 
    links: [
      [ YOUTUBE, EXTERNAL, "https://youtu.be/Ahfk0hvpCzM" ], 
    ], 
  }, 
  {
    title : 'SCP draft: not-inverse square law', 
    year : 2021, 
    pride : 5, 
    tags : [scp, physics], 
    description : 'An SCP draft. Note that sharing a sandbox page as a finished document is discouraged. Feedback welcome.', 
    img : 'notInverseSquareLaw.jpg', 
    links: [
      [ GO, EXTERNAL, "http://scp-sandbox-3.wikidot.com/daniel-chin" ], 
    ], 
  }, 
  {
    title : 'Mana Circuit', 
    year : 2023, 
    pride : 6, 
    tags : [game, godot, geb, math], 
    description : 'A game about magic, gems, math, and computer science.', 
    img : 'mana_circuit.png', 
    links: [
      [ GO, EXTERNAL, "https://daniel-chin.itch.io/mana-circuit" ], 
      [ SOURCE_CODE, EXTERNAL, "https://github.com/Daniel-Chin/Mana-Circuit" ], 
      [ "Web Version", INTERNAL, "manaCircuit/index.html" ], 
    ], 
  }, 
  {
    title : 'Oasis balcony clip', 
    year : 2023, 
    pride : 5, 
    tags : [_3d_print, fabrication], 
    description : 'This 3D model clips onto the balcony walls to provide privot points for the clothe hanging rope. For Oasis residences in Masdar City, Abu Dhabi. ', 
    img : 'masdar_oasis_balcony_clip.jpg', 
    links: [
      [ "3D model (STL)", INTERNAL, "masdar_oasis_balcony_clip.stl" ], 
      [ YOUTUBE, EXTERNAL, "https://youtu.be/KLx6O4MpSIY?si=74VNJJaYbPHsiYqr" ], 
    ], 
  }, 
];

export default portfolio_root;
